module.exports = __webpack_public_path__ + "static/media/ResumeTemplate1.4e6a9608.pdf";